/* eslint-disable prettier/prettier */
// import luckdrawBg from "../../../ui/2021king_newyear/assets/face1.png"
// import squalDrawBg from "../../../ui/2021king_newyear/assets/9-img1.png"
// import individualDrawImg from "../../../ui/2021king_newyear/assets/td-jc-img.png"
// import businessLogo from "../../../ui/2021king_newyear/assets/logo02.png"
// import txczLogo from "../../../ui/2021king_newyear/assets/logo01.png"
// import wxLogo from "../../../ui/2021king_newyear/assets/w-logo.png"
export const TAB = {
  MY_TEAM: 1,
  APPROVAL: 2
}
export const JOINSTATUS = {
  JOINED: "joined",
  APPLY: "apply",
  INVALID: "invalid"
}

export const PEROID = {
  PK: "pk",
  FORMATION: "formation",
  PREPARE: "prepare",
  END: "end",
  NOTSTART: "notstart"
}

export const PRIZESTATUS = {
  LOCKED: "locked", //组队期都未解锁
  RECEIVED: "received", //pk期已经领取
  AVAILABLE: "available", //pk期可以领取
  UNAVAILABLE: "unavailable"
}

export const PRIZE_TAB = {
  TEAM: "team",
  INDIVIDUAL: "individual"
}

export const MQQ_URL = "//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152"

export const GAME_TYPE = {
  MOBLIE_GAME: 1,
  PC_GAME: 3
}

const info = {
  toolsId: 69,
  title: "春节组队PK活动",
  name: "team_pk",
  publishPath: "team_pk_config",
  publishType: "json",
  publishHost: null,
  itemsType: "map",
  publishScope: "single",
  status: 0,
  groupid: "TEAM2201120431072305",
  quitTeamCountDown: "24",
  conversionTime: "2022/02/14 23:59:59",
  pagesize: "25",
  "luckDrawItem": [
    {
      "type": "lotteryImg",
      "num": "1500",
      "card_id": "LUCK2201140403087983",
      "img_url": "",
      "prize": [
        {
          "order": ""
        }
      ]
    },
    {
      "type": "lotteryImg",
      "num": "12500",
      "card_id": "LUCK2201140400242074",
      "img_url": ""
    },
    {
      "type": "lotteryImg",
      "num": "50000",
      "card_id": "LUCK2201140355289727",
      "img_url": ""
    },
    {
      "type": "lotteryImg",
      "num": "100000",
      "card_id": "LUCK2201130508016091",
      "img_url": ""
    },
    {
      "type": "lotteryImg",
      "num": "988",
      "card_id": "LUCK2201140407547944",
      "img_url": ""
    }
  ],
  defaultAvatar: "//midas.gtimg.cn/h5/bargain/static/images/wzry_bargain_share.png",
  SHARE_INFO: {
    INDEX: {
      TITLE: "王者新春年货节 一起消费赢好礼～",
      DESC: "集合！好友一起玩！超值皮肤等你解锁～",
      ICON: "//midas.gtimg.cn/store_config/1611919408312wjTyJFIK.png",
      INGAME_BASE64_ICON:
        "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"
    },
    DETAIL: {
      INGAME_BASE64_ICON:
        "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",
      TITLE: "王者新春年货节，就等你来！",
      DESC: "一起来解锁超值皮肤吧～",
      ICON: "//midas.gtimg.cn/store_config/1611919411625RnBmYcdS.png"
    },
    POSTER: {
      IMG: "//midas.gtimg.cn/store_config/1642075036830q3HN9KXy.png",
      LOGO: "//midas.gtimg.cn/store_config/1576827220256EkM8rp7x.png"
    }
  },
  ads: [
    {
      url: "https://pay.qq.com/h5/activity/bargain/wzry-post-office.php?pf=__mds_act_team_ad_activity",
      img: "//midas.gtimg.cn/store_config/1611909985346VSG2oTRy.jpg",
      shownInGame: true
    },
    {
      shownInGame: true,
      img: "//midas.gtimg.cn/store_config/1611909999091NiMjDuH.jpg",
      url: "https://pay.qq.com/m/active/activity_dispatcher.php?id=2565&pf=__mds_act_team_ad_activity"
    },
    {
      shownInGame: true,
      img: "//midas.gtimg.cn/store_config/1611910008807x8TfNTap.jpg",
      url: "https://pay.qq.com/h5/shop.shtml?pf=__mds_act_team_ad_activity&hash=%2FtaskCenter%2F2%2Fbiz%2F2"
    },
    {
      shownInGame: true,
      img: "//midas.gtimg.cn/store_config/1612865451054cPZqYW1y.jpg"
    }
  ],
  queryStrangerTeam: true,
  queryParticipant: true,
  activityInfo: [
    {
      period: "pk",
      begin_time: "2022/01/28 00:00:00",
      end_time: "2022/02/20 23:59:59",
      "present_item": [
        {
          "img": "//midas.gtimg.cn/store_config/1611557335520lpaXgCtg.png",
          "num": "1500",
          "gifttips": "",
          "name": "恭祝新禧福袋",
          "mainImg": "//midas.gtimg.cn/store_config/164251610040895yoPH1d.png"
        },
        {
          "img": "//midas.gtimg.cn/store_config/1611557361554rPUwlT6F.png",
          "num": "12500",
          "probabilityTips": "",
          "gifttips": "",
          "name": "花开富贵福袋",
          "mainImg": "//midas.gtimg.cn/store_config/164251610040895yoPH1d.png"
        },
        {
          "img": "//midas.gtimg.cn/store_config/1611557376216XUJXr7Wv.png",
          "num": "50000",
          "probabilityTips": "",
          "gifttips": "",
          "name": "心想事成福袋",
          "mainImg": "//midas.gtimg.cn/store_config/164251610040895yoPH1d.png"
        },
        {
          "img": "//midas.gtimg.cn/store_config/1611557396031oUKyHQom.png",
          "num": "100000",
          "probabilityTips": "",
          "gifttips": "",
          "name": "虎虎生威福袋",
          "mainImg": "//midas.gtimg.cn/store_config/164251610040895yoPH1d.png"
        }
      ],
      "individual_present_type": [
        {
          "name": "开门大吉福袋",
          "num": "188",
          "type": "goodsImg",
          "img": "//midas.gtimg.cn/store_config/1611557396031oUKyHQom.png",
          "mainImg": "//midas.gtimg.cn/store_config/1611580228112AneWFGt1.png",
          "resultName": "积分夺宝抵扣券*1",
          "resultImg": "//midas.gtimg.cn/store_config/1611580228112AneWFGt1.png"
        },
        {
          "name": "万事如意福袋",
          "num": "988",
          "type": "lotteryImg",
          "img": "//midas.gtimg.cn/store_config/161158023267729wqxmyJ.png",
          "url": "",
          "mainImg": "//midas.gtimg.cn/store_config/164251610040895yoPH1d.png",
          "resultName": "抽奖"
        },
        {
          "name": "招财进宝福袋",
          "num": "3888",
          "type": "goodsImg",
          "img": "//midas.gtimg.cn/store_config/1611557396031oUKyHQom.png",
          "url": "",
          "mainImg": "//midas.gtimg.cn/store_config/1642474570873Q6dW7lUW.png",
          "resultName": "积分夺宝抵用券抽奖礼包*1",
          "resultImg": "//midas.gtimg.cn/store_config/1642474570873Q6dW7lUW.png"
        },
        {
          "name": "虎神送福福袋",
          "num": "8888",
          "url": "",
          "type": "goodsImg",
          "img": "//midas.gtimg.cn/store_config/1611557396031oUKyHQom.png",
          "mainImg": "//midas.gtimg.cn/store_config/1642474577174iDj4r3iy.png",
          "resultName": "特效头像框*1",
          "resultImg": "//midas.gtimg.cn/store_config/1642474577174iDj4r3iy.png"
        }
      ]
    },
    {
      period: "formation",
      begin_time: "2022/01/20 00:00:00",
      end_time: "2022/01/27 18:00:00"
    }
  ],
  propsConfig: {
    url: "//pay.qq.com/h5/active/static_data/wzry/wzry_props_config_map.json",
    version: "20200111"
  },
  GAME_URL: "//pvp.qq.com/act/a20190121apk/index.html",
  maxJoinQuantity: "25",
  weixinQuitTeamCountDown: "24",
  pagetitle: "王者荣耀组队活动",
  model: {
    ios: "wzry_partition_ios_recomm",
    android: "wzry_partition_android_recomm"
  },
  consumeAds: {
    busId: "2",
    url: "//pay.qq.com/h5/ads/77.json"
  },
  subscribeGroups: "20210118",
  CSS_URL: "//midas.gtimg.cn/store_config/1611928850038vKAjLxrt.css",
  zoneJs: {
    url: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/yxzj_server_select_utf8.js",
    key: "YXZJServerSelect"
  },
  SHARE_URL: "https://pay.qq.com/m/active/activity_dispatcher.php?id=2744",
  shop: {
    bizId: "2",
    busId: "2",
    currency: "点券"
  },
  indexLogos: {
    business: "//midas.gtimg.cn/store_config/1611753124971W5Hhww3.png",
    txcz: "//midas.gtimg.cn/store_config/1611753141521BP678ncG.png",
    pflogo: [
      {
        logo: "//midas.gtimg.cn/store_config/16117548089474O4Y44at.png",
        pf: "__mds_wxgame_banner"
      },
      {
        logo: "//midas.gtimg.cn/store_config/1611844607923yjSKxNNY.png",
        pf: "__mds_daoju_banner"
      },
      {
        logo: "//midas.gtimg.cn/store_config/1611844665494bddJhzXp.png",
        pf: "__mds_weishi_game"
      },
      {
        logo: "//midas.gtimg.cn/store_config/1611915609931JQeP14h.png",
        pf: "__mds_txsp_store"
      },
      {
        logo: "//midas.gtimg.cn/store_config/16122524173347tXVi14A.png",
        pf: "__mds_qqgame_banner"
      }
    ]
  },
  rules: "<div class=\"r-title\"><i></i>一、活动名称</div><p class=\"r-txt\">王者新春年货节 组队消费赢好礼活动</p><div class=\"r-title\"><i></i>二、活动时间</div><p class=\"r-txt\">2022年1月20日00:00:00～2021年2月13日23:59:59</p><div class=\"r-title\"><i></i>三、活动参与流程</div><p class=\"r-txt\">创建战队/加入他人战队——组队成功（需至少1位队友）——消费——领奖</p><div class=\"r-title\"><i></i>四、活动参与资格</div><p class=\"r-txt\">本活动参与者应为具有完全民事行为的自然人，每个自然人使用自己合法所有的王者荣耀游戏账号参与活动。</p><div class=\"r-title\"><i></i>五、活动规则详情</div><p class=\"r-txt\">组队期，自2022年1月20日00:00:00起至2021年1月27日18:00:00止：</p><p class=\"r-txt\">1）玩家可以选定游戏角色后创建战队或加入他人战队，每个战队最多含25人。每位玩家仅可加入唯一1个战队；</p><p class=\"r-txt\">2）创建战队后即可邀请好友入队，当战队内仅队长1人时可解散战队，队内有队友时，队长不可踢人/不可解散战队；</p><p class=\"r-txt\">3）加入他人战队后有24小时的反悔期，玩家可选择退出当前战队，超过24小时后不可再退出；</p><p class=\"r-txt\">4）组队期结束时，成员仅1人的战队将被系统自动解散；</p><p class=\"r-txt\">5）微信/QQ区玩家不互通，即微信区玩家与QQ区玩家无法加入同一个战队。</p><p class=\"r-txt\">&nbsp;</p><p class=\"r-txt\">消费期，自2022年1月28日00:00:00起至2021年2月13日23:59:59止：</p><p class=\"r-txt\">1）队内成员消耗王者荣耀点券/现金/Q币购买英雄皮肤时可累计，王者荣耀游戏内商城、腾讯充值王者荣耀专区、王者营地（不包含内容带货和赛事类道具）、道聚城、微信游戏中心-游戏礼品站、QQ手游、腾讯视频爱玩、微视等渠道均计入累计；</p><p class=\"r-txt\">2）成员消耗金额将共同累计，解锁对应【团队奖励】，奖励被解锁后队内所有成员均可获得1次夺宝资格；成员需消费任意点券才能领取团队奖励；</p><p class=\"r-txt\">3）组队成功的每位玩家，有自己独立任务进度，达到指定门槛可领取【个人奖励】；</p><p class=\"r-txt\">4）消费期结束后，不再继续累计消费；</p><p class=\"r-txt\">5）消费期战队累计消费金额系统自动累计，每2分钟刷新1次；</p><p class=\"r-txt\">6）发红包、扫码付、钻石/金币购买等概不计入活动统计；淘宝、咸鱼、拼多多、京东等第三方私人渠道消费不计入统计。</p><p class=\"r-txt\">&nbsp;</p><p class=\"r-txt\">领奖期，自2021年1月28日00:00:00起至2021年2月17日23:59:59止：</p><p class=\"r-txt\">领奖期消费行为不再继续累积，但已经达到门槛的奖励可继续领取；</p><p class=\"r-txt\">所有奖品中奖后系统自动发货，请玩家返回游戏内邮箱查收，若遇到网络拥堵可能会有延迟，请耐心等待。</p><div class=\"r-title\"><i></i>六、参与资格、获奖资格的取消</div><p class=\"r-txt\">1 、不符合参与资格的；</p><p class=\"r-txt\">2 、提供虚假信息的；</p><p class=\"r-txt\">3 、虚假交易或恶意破坏活动的；</p><p class=\"r-txt\">4 、以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的；</p><p class=\"r-txt\">5 、有任何违反诚实信用、公序良俗、公平、公正等原则行为的；</p><p class=\"r-txt\">6 、其他违反相关法规、本规则行为的。</p><p class=\"r-txt\">请用户理性参与活动，活动期间，如用户存在违反法律、法规或违反包括但不限于 《 王者荣耀服务协议 》 及活动合作平台规则，包括但不限于以作弊等非正当方式获取奖品等行为，腾讯公司有权取消用户中奖资格，撤销违规交易，收回奖品或权益。如有疑问，请戳王者荣耀客服咨询相关事宜。</p><div class=\"r-title\"><i></i>七、组队消费奖励</div><p class=\"r-txt\">组队成功队伍消费可领取奖励，奖励分为四个档次，具体的奖励如下：</p><p class=\"r-txt\">【一档】消费达到100000点券可领取的奖品和概率：</p><p class=\"r-txt\">皮肤碎片x20（12.20%）</p><p class=\"r-txt\">暗夜猫娘（0.10%）</p><p class=\"r-txt\">电玩小子（0.10%）</p><p class=\"r-txt\">苍穹之光（0.10%）</p><p class=\"r-txt\">史诗皮肤池（5.50%）</p><p class=\"r-txt\">勇者皮肤池A（26.00%）</p><p class=\"r-txt\">勇者皮肤池B（26.00%）</p><p class=\"r-txt\">热门皮肤池（30.00%）</p><p class=\"r-txt\">【二档】消费达到50000点券可领取的奖品和概率：</p><p class=\"r-txt\">皮肤碎片x10（8.80%）</p><p class=\"r-txt\">女仆咖啡（0.10%）</p><p class=\"r-txt\">遇见神鹿（0.10%）</p><p class=\"r-txt\">勇者皮肤池A（2.00%）</p><p class=\"r-txt\">勇者皮肤池B（2.00%）</p><p class=\"r-txt\">热门皮肤池（87.00%）</p><p class=\"r-txt\">【三档】消费达到12500点券可领取的奖品和概率：</p><p class=\"r-txt\">热门皮肤池（6.00%）</p><p class=\"r-txt\">积分夺宝抵扣券x1（25.00%）</p><p class=\"r-txt\">皮肤碎片x5（14.00%）</p><p class=\"r-txt\">积分夺宝抵用券抽奖礼包x1（10.00%）</p><p class=\"r-txt\">荣耀积分×30（30.00%）</p><p class=\"r-txt\">点券优惠卡x80（通用）（15.00%）</p><p class=\"r-txt\">【四档】消费达到1500点券可领取的奖品和概率：</p><p class=\"r-txt\">皮肤碎片x1（15.00%）</p><p class=\"r-txt\">英雄碎片x1（15.00%）</p><p class=\"r-txt\">钻石x28（10.00%）</p><p class=\"r-txt\">铭文碎片x28（10.00%）</p><p class=\"r-txt\">荣耀积分×10（30.00%）</p><p class=\"r-txt\">点券优惠卡x80（通用）（20.00%）</p><div class=\"r-title\"><i></i>八、个人消费奖励</div><p class=\"r-txt\">玩家成功消费可领取奖励，奖励分为四个档次，具体的奖励如下：</p><p class=\"r-txt\">【一档】消费达到8888点券可领取的奖品和概率：</p><p class=\"r-txt\">特效头像框x1（100.00%）</p><p class=\"r-txt\">【二档】消费达到3888点券可领取的奖品和概率：</p><p class=\"r-txt\">积分夺宝抵用券抽奖礼包x1（100%）</p><p class=\"r-txt\">【三档】消费达到988点券可领取的奖品和概率：</p><p class=\"r-txt\">孙尚香 水果甜心（0.50%）</p><p class=\"r-txt\">妲己 女仆咖啡（0.50%）</p><p class=\"r-txt\">战令币x80（15.00%）</p><p class=\"r-txt\">S26战令经验包x2（15.00%）</p><p class=\"r-txt\">紫星币x5（15.00%）</p><p class=\"r-txt\">铭文碎片x1600（30.00%）</p><p class=\"r-txt\">浓情玫瑰x3（15.00%）</p><p class=\"r-txt\">积分夺宝抵扣券x3（9.00%）</p><p class=\"r-txt\">【四档】消费达到188点券可领取的奖品和概率：</p><p class=\"r-txt\">积分夺宝抵扣券x1（100.00%）</p><div class=\"r-title\"><i></i>九、积分夺宝抵用券抽奖礼包概率公示：</div><p class=\"r-txt\">积分夺宝抵用券x50（0.1%）</p><p class=\"r-txt\">积分夺宝抵用券x20（0.1%）</p><p class=\"r-txt\">积分夺宝抵用券x10（0.8%）</p><p class=\"r-txt\">积分夺宝抵用券x7（15%）</p><p class=\"r-txt\">积分夺宝抵用券x5（35%）</p><p class=\"r-txt\">积分夺宝抵用券x3（49%）</p>",
  weixinrules:"",
  itemTitle: "王者荣耀组队pk",
  itemId: 2758,
  keyName: "1450019044",
  publishTime: "2021-02-10T18:26:09.931Z"
}

export const REPORT = {
  PAGEVIEW: {
    //组队期-首页-自由用户身份（非队长/队员）
    NEW_USER: "pageview.act_team.visitor",
    //组队期-弹窗-创建战队成功
    TEAM_CREATE_SUCCESS_DIALOG: "pageview.act_team.popup_create",

    // 组队期-弹窗-抽奖弹窗
    FORMATION_LOTTERY: "pageview.act_team.popup_lottery", //todo
    //组队期-详情页队长）
    DETAIL_CAPTION: "pageview.act_team.leader",
    // 组队期-详情页-可以申请加入战队（新用户）
    DETAIL_NEW_USER: "pageview.act_team.staff_apply",

    // 组队期-详情页-等待申请通过（队员）
    DEATIL_APPLY_USER: "pageview.act_team.staff_wait",
    // 组队期-详情页-已经加入战队（队员）
    DETAIL_TEAM_MEMBER: "pageview.act_team.staff",
    // 蓄水期-详情页-组队成功-队长
    DETAIL_TEAM_FORM_SUCCCESS_FROM_CAPTAIN: "pageview.act_team.leader_suc",
    // 蓄水期-详情页-组队成功-队员
    DETAIL_TEAM_FORM_SUCCESS_FROM_MEMBER: "pageview.act_team.visitor_suc",
    // 蓄水期-详情页-组队失败
    DETAIL_TEAM_FORM_FAILED: "pageview.act_team.leader_fail",
    // 蓄水期-详情页-到期后没加入过战队
    DETAIL_USER_NEVER_JOIN: "pageview.act_team.visitor_fail",
    // 消费期-首页
    DETAIL_CONSUME: "pageview.act_team.homepage_pay",

    // 消费期-抽奖弹窗-可以抽
    LOTTERY_CAN_DRAW: "pageview.act_team.popup_lottery_can",
    // 消费期-抽奖弹窗-没资格不能抽
    LOTTERY_CANNT_DRAW: "pageview.act_team.popup_lottery_cannot",
    // 消费期-抽奖弹窗-奖品弹窗
    LOTTERY_DRAW_SUCCESS_ITEM: "pageview.act_team.popup_lottery_gift",
    // 兑奖期-首页
    ACTIVITY_DOUNTDOWN: "pageview.act_team.homepage_countdown",
    // 活动已结束
    ACTIVITY_EXPIRED: "pageview.act_team.homepage_finish",

    //查申请列表异常
    GET_TEAM_APPLY_ERROR: "pageview.act_team.get_team_apply_error",

    //查团队消费异常
    GET_TEAM_CONSUME_ERROR: "pageview.act_team.get_team_consume_error",
    //领取抽奖资格异常
    GET_LUCKY_COUPON_ERROR: "pageview.act_team.get_lucky_coupon_error",
    //查询抽奖资格异常
    GET_DRAW_QUALIFICATION_ERROR: "pageview.act_team.get_draw_qualification_error",
    //getLuckDrawAward查询团队奖品异常
    QUERY_TEAM_PRESENT_ERROR: "pageview.act_team.query_luckdraw_award_error",

    //抽奖异常
    DRAW_ERROR: "pageview.act_team.draw_error",
    //首页排队
    INDEX_QUEUE: "pageview.act_team.index_queue",
    //详情页异常
    TEAM_QUEUE: "pageview.act_team.team_queue",
    //创建战队异常
    CREATE_TEAM_ERROR: "pageview.act_team.create_team_error",
    //加入战队异常
    JOIN_TEAM_ERROR: "pageview.act_team.join_team_error",
    //退出战队异常
    QUIT_TEAM_ERROR: "pageview.act_team.quit_team_error",
    //设置审批开关异常
    SET_TEAM_APPROVAL_ERROR: "pageview.act_team.set_team_approval_error",
    //解散战队异常
    DISMISS_TEAM_ERROR: "pageview.act_team.dismiss_team_error",
    //队长审批队员异常
    APPROVAL_ERROR: "pageview.act_team.approval_error",
    //陌生人战队刷新异常
    STRANGER_TEAM_ERROR: "pageview.act_team.stranger_team_error",
    //个人奖励领取成功
    GET_INDIVIDUAL_PRIZE_SUC: "pageview.act_team.get_individual_prize_suc",
    //个人奖励领取失败
    GET_INDIVIDUAL_PRIZE_ERROR: "pageview.act_team.get_individual_prize_error",
    //订阅活动成功
    SUBSCRIBE_SUCCESS: "pageview.act_team.subscribe_suc",
    //订阅活动失败
    SUBSCRIBE_ERROR: "pageview.act_team.subscribe_error",
    //获取openlink成功
    GET_OPENLINK_SUC: "pageview.act_team.get_openlink_suc",
    //获取openlink失败
    GET_OPENLINK_ERROR: "pageview.act_team.get_openlink_error"
  },
  CLICK: {
    // 1	查看活动规则
    RULE: "click.act_team.check_rule",
    // 2	切换账号角色
    CHANGE_ROLE: "click.act_team.changerole",
    // 3	点击查看奖池
    CHECK_LOTTERY: "click.act_team.check_lottery",
    // 4	队长-创建战队
    CREATE_TEAM: "click.act_team.createteam",
    // 5	首页-点击加入陌生人战队
    JOIN_STRANGER_TEAM: "click.act_team.join_visitor",
    // 6	先去囤点券
    BUY_GAMECOIN: "click.act_team.buy_gamecoin",
    // 7	查看广告位
    BANNER: "click.act_team.banner",
    // 8	分享-游戏内-微信
    SHARE_WECHAT_IN_GAME: "click.act_team.ingame_share_wechat",
    // 9	分享-游戏内-QQ
    SHARE_QQ_IN_GAME: "click.act_team.ingame_share_qq",
    // 10	分享-游戏内-朋友圈
    SHARE_TIMELINE_IN_GAME: "click.act_team.ingame_share_moment",
    // 11	分享-游戏内-QQ空间
    SHARE_QZONE_IN_GAME: "click.act_team.ingame_share_zone",
    // 12	分享-游戏外-QQ
    SHARE_QQ_OUTSIDE_GAME: "click.act_team.outgame_qqshare",
    // 13	分享-游戏外-QQ成功
    SHARE_QQ_OUTSIDE_GAME_SUCESS: "click.act_team.outgame_qqshare_success",
    // 14	分享-游戏外-QQ失败
    SHARE_QQ_OUTSIDE_GAME_FAILURE: "click.act_team.outgame_qqshare_fail",

    // 15	分享-游戏外-微信
    SHARE_WECHAT_OUTSIDE_GAME: "click.act_team.outgame_wxshare",
    // 16	队长-发布战队召集令
    SHARE_TEAM_FROM_CAPTAIN: "click.act_team.leader_summon",
    // 17	队长-订阅公众号（=队员订阅公众号）
    SUBSCRIBE: "click.act_team.follow",
    // 18	队长-解散战队
    DISMISS: "click.act_team.dissolve",
    // 19	队长-切换审批开关
    SWITCH_APPROVAL: "click.act_team.on-off",
    // 20	队长-查看我的战队
    MY_TEAM: "click.act_team.myteam",
    // 21	队长-查看战队申请
    CHECK_APPLY_LIST: "click.act_team.checkapply",
    // 22	队长-通过申请
    PASS_APPLY: "click.act_team.checkapply_pass",
    // 23	队长-忽略申请
    IGNORE_APPLY: "click.act_team.checkapply_ignore",
    // 24	队员-申请加入战队(=提醒队长审核）
    ALERT_CAPTAIN_APPROVAL: "click.act_team.join_staff",
    // 25	返回首页-创建自己的战队
    BACK_TO_INDEX_CREATE_TEAM: "click.act_team.backhomepage",
    // 26	队员-发布战队召集令
    SHARE_TEAM_FROM_MEMBER: "click.act_team.staff_summon",
    // 27	队员-退出战队
    QUIT_TEAM: "click.act_team.staff_quit",
    // 28	队长-创建QQ群
    CREATE_QQ_GROUP: "click.act_team.QQgroup",

    // 30	消费期-点击“已达成”
    LOTTERY_RECEIVE: "click.act_team.lottery_go",
    // 31	消费期-点击“未达成”
    LOTTERY_UNREACH: "click.act_team.lottery_lock",
    // 32	消费期-继续贡献
    CONTINUE_CONSUME: "click.act_team.pay_gamecoin",
    // 33	抽奖弹窗-点击抽奖
    START_DRAW: "click.act_team.popup_start",
    // 34	抽奖弹窗-点击去游戏
    DRAW_RECEIVED: "click.act_team.popup_ingame"
  }
}

export const GAME_INFO = window.teamPKConfig || info
